import Sidebar from './Sidebar';
import Header from './Header';
import {Link, Outlet, useLocation} from 'react-router-dom';
import {useEffect, useState} from 'react';
import Spinner from '../../components/button/Spinner';
import {cnpj, cpf} from 'cpf-cnpj-validator';
import api from '../../services/api';

export default function Main() {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const [billetsToPay, setBilletsToPay] = useState(0);
    const nameCapitalized = user.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');


    useEffect(() => {
    api.get('/billets/' + user.document )
            .then((response) => setBilletsToPay(response.data.length))
            .finally(() => setLoading(false));
        setLoading(true);
    }, [user.document]);

    return (
        <>
            <Header/>
            <Sidebar/>
            <div className="pt-8 sm:pl-48 pl-0">
                {location.pathname === '/' && (
                    <>
                        <h2 className="text-lg ml-10 mt-14 text-current bold">
                            <span className="font-bold"> Bem vindo </span>
                            {nameCapitalized} - {user.document.length === 11 ? cpf.format(user.document) : cnpj.format(user.document)}
                        </h2>
                        <div className="h-2 mt-5 ml-10">
                            <Spinner loading={loading}/>
                        </div>
                        <section className="flex ml-10 mt-10 ">
                            <Link to="/billets"
                                  className="shadow-xl border-gray-200  shadow-gray-700 border-2 rounded-md m-2">
                                <div className="bg-blue-400 pb-2 px-2  rounded-md text-center">
                                <span
                                    className="text-2xl font-semibold text-white block pb-2 text-center px-2">Boletos em Aberto</span>
                                </div>
                                <span
                                    className="text-base font-semibold mt-2 text-center block">Você tem {billetsToPay} boletos pendente(s)</span>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-40 w-40 mx-auto" fill="none"
                                     viewBox="0 0 24 24"
                                     stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1}
                                          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                                </svg>
                            </Link>
                        </section>
                    </>
                )}
                <Outlet/>
            </div>
        </>
    );
}
